import { decodeOnce } from '@/lib/travel/path'
import type { Locale } from '@/i18n/locales'
import { routing } from '@/i18n/routing'

/*
 * The airport-shuttle guide's `/{locale}/airport-shuttles/{airport}/` namespace, parsed by
 * structure alone: the locale is a group this app declares, and the segment beneath is
 * carried as written (→ invariants.md#url-validity-is-the-stores-answer). Which airports
 * are pages is the manifest's answer, and who answers a request the request boundary's.
 */

export const AIRPORT_SHUTTLES_SEGMENT = 'airport-shuttles'

export interface AirportShuttlePath {
    readonly locale: Locale
    /** `/airport-shuttles/{airport}`, the segment as requested. */
    readonly slug: string
}

/** `/en-us/airport-shuttles/boston-logan--bos/` → its locale and slug, or `undefined` for a
 *  path outside the namespace. */
export function airportShuttlePath(pathname: string): AirportShuttlePath | undefined {
    const [empty, locale = '', first = '', ...segments] = pathname.replace(/\/$/, '').split('/')
    if (empty !== '' || first !== AIRPORT_SHUTTLES_SEGMENT || segments.length !== 1) {
        return undefined
    }
    if (segments[0] === '' || !(routing.locales as readonly string[]).includes(locale)) {
        return undefined
    }
    return { locale: locale as Locale, slug: `/${AIRPORT_SHUTTLES_SEGMENT}/${segments[0]}` }
}

/** The slug the page type serves for an airport segment, decoded once. */
export const airportShuttleSlug = (segment: string): string =>
    `/${AIRPORT_SHUTTLES_SEGMENT}/${decodeOnce(segment)}`
